

<ion-list lines="none">
  <ion-item>
    <ion-icon
      (click)="goBack()"
      tooltip="Back"
      aria-label="Go Back"
      src="/assets/icons/24px/line-arrow-left.svg"
      slot="start"
      id="back-button"> </ion-icon>

    <ion-label>
      Select a Take
    </ion-label>
  </ion-item>

  <ion-item *ngFor="let take of takes" (click)="selectTake(take)" button="true">
    <ion-icon src="/assets/icons/24px/descript.svg" slot="start"></ion-icon>

    <ion-label>
      <span *ngIf="take.takeName">
        {{ take.takeName }}
      </span>
      <span *ngIf="!take.takeName">
        Take {{ take.takeNumber }}
      </span>
    </ion-label>
  </ion-item>
</ion-list>
